// Enlaces "Agregar a mi calendario" para los dos días del evento.
// Horarios en hora de Ciudad de México (UTC-6 en noviembre).

const TZ = 'America/Mexico_City';
const SITE = 'https://liderazgo.ochenta20.com';

export const events = [
  {
    key: 'sabado',
    title: 'Escuela de Liderazgo con Yahir Pérez',
    start: '20261114T133000',
    end: '20261114T180000',
    location: 'Hotel Fiesta Inn Plaza San Marcos, Av. Chalma esq. Autopista México-Querétaro, Cuautitlán Izcalli, Edo. de México',
    description: `Sábado 14 de noviembre. Para tabuladores, Equipos del Mundo y Equipos del Mundo Activo con boleto. Acceso y registro 13:30. Presenta tu confirmación de pago en la entrada. Más información: ${SITE}`,
  },
];

export function googleCalendarUrl(ev) {
  const p = new URLSearchParams({
    action: 'TEMPLATE',
    text: ev.title,
    dates: `${ev.start}/${ev.end}`,
    ctz: TZ,
    location: ev.location,
    details: ev.description,
  });
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
}

function icsEscape(s) {
  return String(s).replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\n/g, '\\n');
}

export function icsDataUrl(ev) {
  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Ochenta20//Escuela de Liderazgo//ES',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${ev.key}-2026@liderazgo.ochenta20.com`,
    `DTSTAMP:20261007T000000Z`,
    `DTSTART;TZID=${TZ}:${ev.start}`,
    `DTEND;TZID=${TZ}:${ev.end}`,
    `SUMMARY:${icsEscape(ev.title)}`,
    `LOCATION:${icsEscape(ev.location)}`,
    `DESCRIPTION:${icsEscape(ev.description)}`,
    `URL:${SITE}`,
    'BEGIN:VALARM',
    'TRIGGER:-P1D',
    'ACTION:DISPLAY',
    'DESCRIPTION:Mañana es la Escuela de Liderazgo',
    'END:VALARM',
    'END:VEVENT',
    'END:VCALENDAR',
  ];
  return 'data:text/calendar;charset=utf-8,' + encodeURIComponent(lines.join('\r\n'));
}
